import { useOrganization } from '@clerk/clerk-react'
import { AuthLayout } from '../components/layout/AuthLayout'
import { AgentChat } from '../components/AgentChat'
import { ConversationProvider } from '../contexts/ConversationContext'

interface AgentProps {
  agent: 'david' | 'hanna'
}

export function Agent(props: AgentProps) {
  const { agent } = props
  const { organization } = useOrganization()
  return (
    <ConversationProvider key={organization?.id} agentId={agent}>
      <AuthLayout chatComponent={<AgentChat />} />
    </ConversationProvider>
  )
}
